module.exports = __webpack_public_path__ + "img/IMG_6258_L_BlackMatted.6f38c5da.jpg";